/**
 * Full-screen confetti + side “firework” cannons (hidden sidebar brand easter egg).
 * For Media Devoted | Created By Ciro Autiero
 */

import confetti from 'canvas-confetti';

type Confetti = typeof confetti;

/** Respects `prefers-reduced-motion` (no animation when enabled). */
const A11Y = { disableForReducedMotion: true as const };

const PALETTE = [
  '#3b82f6',
  '#6366f1',
  '#8b5cf6',
  '#a855f7',
  '#ec4899',
  '#f97316',
  '#eab308',
  '#22c55e',
];

function runSideCannons(confetti: Confetti, until: number): void {
  const step = (): void => {
    if (Date.now() > until) return;
    const y = Math.random() * 0.35 + 0.25;
    confetti({
      ...A11Y,
      particleCount: 4,
      angle: 60,
      spread: 52,
      origin: { x: 0, y },
      colors: PALETTE,
      startVelocity: 48,
      gravity: 1.05,
      scalar: 0.95,
      ticks: 220,
    });
    confetti({
      ...A11Y,
      particleCount: 4,
      angle: 120,
      spread: 52,
      origin: { x: 1, y },
      colors: PALETTE,
      startVelocity: 48,
      gravity: 1.05,
      scalar: 0.95,
      ticks: 220,
    });
    requestAnimationFrame(step);
  };
  requestAnimationFrame(step);
}

function runCenterShow(confetti: Confetti): void {
  confetti({
    ...A11Y,
    particleCount: 120,
    spread: 360,
    origin: { x: 0.5, y: 0.48 },
    colors: PALETTE,
    startVelocity: 38,
    gravity: 0.85,
    ticks: 340,
    scalar: 1.05,
  });
  window.setTimeout(() => {
    confetti({
      ...A11Y,
      particleCount: 90,
      spread: 95,
      origin: { x: 0.5, y: 0.32 },
      colors: PALETTE,
      startVelocity: 32,
      ticks: 280,
    });
  }, 200);
  window.setTimeout(() => {
    confetti({
      ...A11Y,
      particleCount: 70,
      angle: 270,
      spread: 50,
      origin: { x: 0.5, y: 0.12 },
      colors: PALETTE,
      startVelocity: 58,
      ticks: 260,
    });
  }, 450);
}

export function playSidebarConfetti(): void {
  runCenterShow(confetti);
  runSideCannons(confetti, Date.now() + 3400);
}
